import React from 'react';
import { useLocation } from 'react-router-dom';
import DoctorKitsDetails from 'components/business/doctor-kits/DoctorKitsDetails';
import DoctorKits from '../components/business/DoctorKits';

export const ConcentsCtx = React.createContext({});

function DoctorKitsPageProvider(props) {
  const ctx = {
  };
  return (
    <ConcentsCtx.Provider value={ ctx }>
      {props.children}
    </ConcentsCtx.Provider>
  );
}

function DoctorKitsPage() {
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  if (null != id) {
    return <DoctorKitsDetails id={ id } />;
  }

  return (
    <DoctorKitsPageProvider>
      <DoctorKits />
    </DoctorKitsPageProvider>
  );
}

export default DoctorKitsPage;
